@let mainChannelValue = mainChannel$ | async;
@let allChannelsOptions = allChannelsOptions$ | async;
@let otherChannelsValues = otherChannels$ | async;

<div class="mm-profile-page"
     [class.mm-profile-page-position-inherit]="!openAsCard">
    <div class="mm-profile-profile" *ngIf="(profileData | async) as profileData">

        <div class="mm-profile-info" *ngIf="profileData.email !== profileData.identifier">
            <div class="mm-profile-info-title">
                {{ 'profile.identifier'| translate }}:
            </div>
            <div class="mm-profile-info-data">
                {{ profileData.identifier }}
            </div>
        </div>

        <div class="mm-profile-info">
            <div class="mm-profile-info-title">
                @if (profileData.email === profileData.identifier) {
                    <ng-container>
                        {{ 'profile.emailAndIdentifier'| translate }}:
                    </ng-container>
                }
                @if (profileData.email !== profileData.identifier) {
                    <ng-container>
                        {{ 'profile.email'| translate }}:
                    </ng-container>
                }
            </div>
            <div class="mm-profile-info-data">
                {{ profileData.email ?? '-' }}
            </div>
        </div>

        @if (profileData.displayName !== undefined) {
            <div class="mm-profile-info">
                <div class="mm-profile-info-title">
                    {{ 'profile.name'| translate }}:
                </div>
                <div class="mm-profile-info-data">
                    {{ profileData.displayName }}
                </div>
            </div>
        }

        <div class="mm-profile-info">
            <div class="mm-profile-info-title">
                {{ 'profile.organizationName'| translate }}:
            </div>
            <div class="mm-profile-info-data">
                {{ profileData.organizationName !== undefined ? profileData.organizationName : ('profile.noOrganization'| translate) }}
            </div>
        </div>

        <hr class="mm-profile-profile-separator">

        <div class="mm-profile-profile-edit-section"
             [class.mm-profile-edit-section-editor]="localeEditorActive">
            @if (!localeEditorActive && !doNotAllowToEdit) {
                <div (click)="openLocaleEditor()"
                     class="mm-profile-profile-edit-section-button"
                     [title]="'profile.editButton'| translate">
                    <app-icon [icon]="'pencil-light'"
                              class="mm-profile-profile-edit-section-button-icon"></app-icon>
                </div>
            }
            @if (!localeEditorActive) {
                <div>
                    <div class="mm-profile-info">
                        <div class="mm-profile-info-title">
                            {{ 'profile.locale'| translate }}
                        </div>
                        <div class="mm-profile-info-data">
                            {{ loadedLocale | locale | async }}
                        </div>
                    </div>
                </div>
            }
            @if (localeEditorActive) {
                <div>
                    <div class="mm-profile-info mm-profile-edit-section-editor-info">
                        <div class="mm-profile-info-title">
                            {{ 'profile.locale'| translate }}
                        </div>
                        <div class="mm-profile-info-data">
                            <form [formGroup]="localeFormData">
                                <app-locale-select formControlName="locale"></app-locale-select>
                            </form>
                        </div>
                    </div>
                    <div class="mm-profile-edit-section-editor-buttons">
                        <app-button [disabled]="localeFormData.disabled" (click)="cancelLocale()"
                                    type="secondary"> {{ 'profile.cancel'| translate }}
                        </app-button>
                        <app-button [disabled]="!localeValueChanged" [action]="saveLocale" type="primary">
                            {{ 'profile.save'| translate }}
                        </app-button>
                    </div>
                </div>
            }
        </div>

        <hr class="mm-profile-profile-separator">

        @if (!mainChannelEditorActive) {
            <div class="mm-profile-profile-edit-section">
                @if (!mainChannelEditorActive && !doNotAllowToEdit && otherChannelsValues !== undefined && otherChannelsValues !== null && otherChannelsValues.length > 0) {
                    <div (click)="openMainChannelEditor()"
                         class="mm-profile-profile-edit-section-button"
                         [title]="'profile.editButton'| translate">
                        <app-icon [icon]="'pencil-light'"
                                  class="mm-profile-profile-edit-section-button-icon"></app-icon>
                    </div>
                }
                <div class="mm-profile-info">
                    <div class="mm-profile-info-title">
                        {{ 'profile.mainChannelLabel'| translate }}:
                    </div>
                    <div class="mm-profile-info-data mm-profile-info-data-main-channel">
                        {{ mainChannelValue !== undefined && mainChannelValue !== null ? getChannelName(mainChannelValue) : '-' }}
                    </div>
                </div>
                @if (otherChannelsValues !== undefined && otherChannelsValues !== null && otherChannelsValues.length > 0) {
                    <div class="mm-profile-info">
                        <div class="mm-profile-info-title mm-profile-info-title-other-channels">
                            {{ 'profile.otherChannels'| translate }}:
                        </div>
                        <div class="mm-profile-info-data mm-profile-info-data-other-channels">
                            <div *ngFor="let channel of otherChannelsValues" class="mm-profile-info-data-other-channel">
                                {{ getChannelName(channel) }}
                            </div>
                        </div>
                    </div>
                }
            </div>
        } @else {
            <div
                class="mm-profile-profile-edit-section mm-profile-edit-section-editor mm-profile-edit-section-editor-channels">
                <div class="mm-profile-edit-section-editor-channels-area">
                    <div class="mm-profile-info mm-profile-edit-section-editor-info">
                        <div class="mm-profile-info-title">
                            {{ 'profile.mainChannelLabel'| translate }}
                        </div>
                        <div class="mm-profile-info-data">
                            <mm-select
                                [options]="allChannelsOptions ?? []"
                                [formControl]="mainChannelFormControl"
                                [style]="darkMode ? 'dark' : 'light'">
                            </mm-select>
                        </div>
                    </div>
                    <div class="mm-profile-edit-section-editor-buttons">
                        <app-button [disabled]="localeFormData.disabled" (click)="cancelMainChannel()"
                                    type="secondary"> {{ 'profile.cancel'| translate }}
                        </app-button>
                        <app-button [disabled]="!mainChannelValueChanged" [action]="saveMainChannelAction"
                                    type="primary">
                            {{ 'profile.save'| translate }}
                        </app-button>
                    </div>
                </div>

                <div class="mm-profile-info mm-profile-info-other-channels">
                    <div class="mm-profile-info-title mm-profile-info-title-other-channels">
                        {{ 'profile.otherChannels'| translate }}:
                    </div>
                    <div class="mm-profile-info-data mm-profile-info-data-other-channels">
                        <div *ngFor="let channel of otherChannelsValues" class="mm-profile-info-data-other-channel">
                            {{ getChannelName(channel) }}
                        </div>
                    </div>
                </div>
            </div>
        }

        @if (profileData.allowToChangePseudonym && profileData.usePseudonym !== undefined) {
            <ng-container>
                <hr class="mm-profile-profile-separator">
                <div class="mm-profile-profile-edit-section"
                     [class.mm-profile-edit-section-editor]="pseudonymEditorActive">
                    @if (!pseudonymEditorActive && !doNotAllowToEdit) {
                        <div (click)="openPseudonymEditor()"
                             class="mm-profile-profile-edit-section-button"
                             [title]="'profile.editButton'| translate">
                            <app-icon [icon]="'pencil-light'"
                                      class="mm-profile-profile-edit-section-button-icon"></app-icon>
                        </div>
                    }
                    @if (!pseudonymEditorActive) {
                        <div class="micromate-profile-pseudonym-info">
                            <div class="mm-profile-info">
                                <div class="mm-profile-info-title">
                                    {{ 'profile.usePseudonym'| translate }}:
                                </div>
                                <div class="mm-profile-info-data">
                                    {{ (profileData.usePseudonym ? 'profile.activePseudonym' : 'profile.inactivePseudonym')| translate }}
                                </div>
                            </div>
                            @if (profileData.usePseudonym) {
                                <div class="mm-profile-info">
                                    <div class="mm-profile-info-title">
                                        {{ 'profile.pseudonym'| translate }}:
                                    </div>
                                    <div class="mm-profile-info-data">
                                        {{ pseudonym }}
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    @if (pseudonymEditorActive) {
                        <div class="micromate-profile-pseudonym-info">
                            <div class="mm-profile-info">
                                <div class="mm-profile-info-title">
                                    {{ 'profile.usePseudonym'| translate }}:
                                </div>
                                <div class="mm-profile-info-data">
                                    <app-switch-toggle [formControl]="usePseudonymFormControl"></app-switch-toggle>
                                </div>
                            </div>
                            <div class="mm-profile-info mm-profile-edit-section-editor-info">
                                @if (usePseudonymFormControl.getRawValue()) {
                                    <div class="mm-profile-info-title">
                                        {{ 'profile.pseudonym'| translate }}:
                                    </div>
                                }
                                @if (usePseudonymFormControl.getRawValue()) {
                                    <div class="mm-profile-info-data">
                                        <div class="mm-profile-edit-section-editor-info-editor">
                                            {{ pseudonym }}
                                            <app-icon *ngIf="!(profilePseudonymService.generatingPseudonym$ | async)"
                                                      (click)="generateNewPseudonym()"
                                                      [icon]="'arrows-rotate-light'"
                                                      class="mm-profile-edit-section-editor-info-generation-button"></app-icon>
                                            <mm-spinner *ngIf="profilePseudonymService.generatingPseudonym$ | async"
                                                        class="mm-profile-edit-section-editor-info-generation-spinner"></mm-spinner>
                                        </div>
                                    </div>
                                }

                            </div>
                            <div class="mm-profile-edit-section-editor-buttons">
                                <app-button (click)="cancelPseudonym()"
                                            type="secondary"> {{ 'profile.cancel'| translate }}
                                </app-button>
                                <app-button (click)="savePseudonym()" type="primary" [disabled]="!pseudonymValueChange">
                                    {{ 'profile.save'| translate }}
                                </app-button>
                            </div>
                        </div>
                    }


                </div>
            </ng-container>
        }

        @if (profileData.allowToChangeLearningReminder) {
            <ng-container>
                <hr class="mm-profile-profile-separator">
                <div class="mm-profile-profile-edit-section"
                     [class.mm-profile-edit-section-editor]="learningReminderEditorActive">

                    @if (!learningReminderEditorActive && !doNotAllowToEdit) {
                        <div (click)="openLearningReminderEditor()"
                             class="mm-profile-profile-edit-section-button"
                             [title]="'profile.editButton' | translate">
                            <app-icon [icon]="'pencil-light'"
                                      class="mm-profile-profile-edit-section-button-icon"></app-icon>
                        </div>
                    }
                    @if (!learningReminderEditorActive) {
                        <div>
                            <div class="mm-profile-info">
                                <div class="mm-profile-info-title">
                                    {{ 'profile.learningReminder' | translate }}:
                                </div>
                                <div class="mm-profile-info-data">
                                    {{ (profileData.learningReminder !== false ? 'profile.learningReminderOn' : 'profile.learningReminderOff') | translate }}
                                </div>
                            </div>
                            @if (profileData.learningReminder !== false) {
                                <div class="mm-profile-info">
                                    <div class="mm-profile-info-title">
                                        {{ 'profile.learningReminderFrequency' | translate }}:
                                    </div>
                                    <div class="mm-profile-info-data">
                                        {{ ('profile.learningReminderFrequency_' + profileData.learningReminderFrequency) | translate }}
                                    </div>
                                </div>
                            }
                        </div>
                    }

                    @if (learningReminderEditorActive) {
                        <div>
                            <div class="mm-profile-info mm-profile-edit-section-editor-info">
                                <div class="mm-profile-info-title">
                                    {{ 'profile.learningReminder' | translate }}:
                                </div>
                                <div class="mm-profile-info-data">
                                    <app-switch-toggle
                                        [formControl]="learningReminderFormData.controls.learningReminder"></app-switch-toggle>
                                </div>
                            </div>
                            @if (learningReminderFormData.controls.learningReminder.getRawValue()) {
                                <div class="mm-profile-info mm-profile-edit-section-editor-info">
                                    <div class="mm-profile-info-title">
                                        {{ 'profile.learningReminderFrequency' | translate }}:
                                    </div>
                                    <div class="mm-profile-info-data">
                                        <mm-select
                                            [options]="learningReminderFrequencyOptions"
                                            [formControl]="learningReminderFormData.controls.learningReminderFrequency"
                                            [style]="darkMode ? 'dark' : 'light'">
                                        </mm-select>
                                    </div>
                                </div>
                            }
                            <div class="mm-profile-edit-section-editor-buttons">
                                <app-button (click)="cancelLearningReminder()" type="secondary">
                                    {{ 'profile.cancel' | translate }}
                                </app-button>
                                <app-button (click)="saveLearningReminder()" type="primary"
                                            [disabled]="!learningReminderValueChanged">
                                    {{ 'profile.save' | translate }}
                                </app-button>
                            </div>
                        </div>
                    }

                </div>
            </ng-container>
        }

        @if (profileData.allowToChangeMonthlyReportActivation) {
            <ng-container>
                <hr class="mm-profile-profile-separator">
                <div class="mm-profile-info">
                    <div class="mm-profile-info-title">
                        {{ 'profile.monthlyReport'| translate }}:
                    </div>
                    <div class="mm-profile-info-data">
                        <app-switch-toggle [formControl]="useMonthlyReportFormControl"
                                           (change)="changeMonthlyReport()"></app-switch-toggle>
                    </div>
                </div>
            </ng-container>
        }

    </div>
</div>
